export default "__VITE_ASSET__CTVL7EV$__";